import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function Message(props) {
    return (
        <div className="right withCount" title={gettext('My Messages')}>
            <a href={Util.reverseURL('workspace:messages')}>
                <div className="Icons_28px messageIcon" style={{ height: 22, marginTop: -2 }} />
                {!!props.messageCount &&
                <div id="HeaderMessageCount" className="count roundBorder6 dropShadowDark">
                    {props.messageCount}
                </div>
                }
            </a>
        </div>
    );
}

Message.propTypes = {
    messageCount: PropTypes.number
};

Message.defaultProps = {
    messageCount: 0
};

const mapStateToProps = state => (
    {
        messageCount: state.getIn(['people', 'messageCount'])
    }
);

export default connect(mapStateToProps)(Message);



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/Message.jsx